module.exports = __webpack_public_path__ + "static/noticias-10--aebb9e7b45fb8d691d5e9e05f6037a1f.png";